import React, {useEffect} from 'react';
import {Link} from 'react-router-dom'
import Group from './Group';

const GroupIndex = ({user, api}) => {

    useEffect(async() => {
        if(!user.jwt) return;
        api.getGroups();
    }, [user])

    if(user.accessLevel < 2) {
      return <div>Unauthorized</div>
    }

    if(!api.data.groups) {
        return <div>Requesting Group list...</div>
    }

    return <table className="table">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Domain</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
    {api.data.groups.map((g) => <Group key={`group_${g.id}`} group={g} api={api} />)}
    <tr><td colSpan="3"><Link to="/group/new">Add new Group</Link></td></tr>
    </tbody>
  </table>
}

export default GroupIndex;